<script>
  import ItemPerPageSelectBox from "../../../components/select/ItemPerPageSelectBox.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import MenuBar from "../../../components/menuBar/MenuBar.svelte";
  import MenuBarItem from "../../../components/menuBar/MenuBarItem.svelte";
  import PageSelector2 from "../../../components/layout/PageSelector2.svelte";
  import GeneralSelect from "../../../components/select/GeneralSelect.svelte";

  /**
   * Available styles
   * @type {{
   *   name: string | null,
   *   index: number | null,
   * }[]}
   */
  export let styles;

  /**
   * Total number of pages
   * @type {number | null}
   */
  export let totalPageNumber = 1;

  /**
   * Current index of the page
   */
  export let currentIndex = 0;

  export let OrderTableStore

  const {
    ItemsPerPage,
    StyleName,
  } = OrderTableStore
</script>

<MenuBar>
  <svelte:fragment slot="settings">
    <MenuBarItem>
      <svelte:fragment slot="label">{translate("asprova.terms.style")}</svelte:fragment>
      <GeneralSelect
        options={styles.map((style) => ({text: style.name, value: style.name}))}
        bind:value={$StyleName}
      />
    </MenuBarItem>
    <MenuBarItem>
      <svelte:fragment slot="label">{translate("frontend:generic.itemsPerPage")}</svelte:fragment>
      <MenuBarItem>
        <svelte:fragment slot="label">{translate("frontend:generic.itemsPerPage")}</svelte:fragment>
        <ItemPerPageSelectBox bind:value={$ItemsPerPage}/>
      </MenuBarItem>
    </MenuBarItem>
  </svelte:fragment>
  <MenuBarItem slot="pagination">
    <PageSelector2 totalPageNumber={totalPageNumber} bind:currentIndex={currentIndex} />
  </MenuBarItem>
</MenuBar>
